$(document).ready(function () {
    console.log("Subscription Widget geladen");

    function formatMoney(amount) {
        let n = Number(amount);
        // Prüfen, ob die Zahl glatt ist (Rest bei Teilung durch 1 ist 0)
        if (n % 1 === 0) {
            return "€ " + n; // Keine Nachkommastellen
        }
        // Sonst wie bisher: 2 Nachkommastellen und Komma statt Punkt
        return "€ " + n.toFixed(2).replace(".", ",");
    }

    function forceTwoDecimalsInSubscription() {
        $(".product-subscription .single-price, .product-subscription .bundle-price del, .product-subscription .subs-price del, .product-subscription .bundle-price .reg_price, .product-subscription .subs-price .reg_price").each(function () {
            let t = $(this).text();

            // nur wenn es wie ein Euro-Preis aussieht
            if (!t.includes("€")) return;

            // Zahl extrahieren
            let raw = t.replace("€", "").trim().replace(/\s+/g, "").replace(",", ".");
            let n = parseFloat(raw);
            
            if (isNaN(n)) return;

            // NEU: Wenn glatte Zahl -> keine Nachkommastellen
            if (n % 1 === 0) {
                $(this).text("€ " + n);
            } else {
                // Sonst: € 35,50
                $(this).text("€ " + n.toFixed(2).replace(".", ","));
            }
        });
    }

    // Aktives Abo-Rabattstufen-Select (alle anderen Stufen sind `disabled`).
    // Ein Splittest-Tool schaltet die Stufe um, indem es disabled/hidden tauscht.
    function activePlanSelect(productContainer) {
        return productContainer.find(".selling_plan").filter(function () {
            return !this.disabled;
        }).first();
    }

    // Abo-Rabatt als Faktor aus data-discount-tier des aktiven Selects, damit
    // die Anzeige immer zum echten price_adjustment des Seal-Plans passt.
    function activeDiscount(productContainer) {
        let tier = parseFloat(activePlanSelect(productContainer).attr("data-discount-tier"));
        if (isNaN(tier) || tier < 0 || tier >= 100) return 0;
        return tier / 100;
    }

    function initializeSubscriptionOptions() {
        $('#selling_plan_id').val('');
    }

    function updateSubscriptionPrice() {
        $(".product-subscription").each(function () {
            let productContainer = $(this);
            
            // Preis auslesen
            let productPrice = parseFloat(
                productContainer.find(".single-price").data("base-price")
            );

            // Fallback, falls data-Attribut leer ist (z.B. bei manchen Themes)
            if (isNaN(productPrice) || productPrice <= 0) {
                 let rawPrice = productContainer.find(".single-price").text().replace("€", "").replace(".-", "").trim().replace(/\s/g,'').replace(",", ".");
                 productPrice = parseFloat(rawPrice);
            }

            if (isNaN(productPrice) || productPrice <= 0) {
                console.warn("Produktpreis konnte nicht ermittelt werden.");
                return;
            }

            let bundleDiscount = 0.15,
                subscriptionDiscount = activeDiscount(productContainer);

            // Berechnungen
            let bundlePrice3 = productPrice * 3 * (1 - bundleDiscount);  // 3er Bundle (15%)
            let bundlePrice4 = productPrice * 4 * 0.75;                  // 3+1 Bundle (25%)
            let subscriptionPrice = productPrice * (1 - subscriptionDiscount);

            // 1. Update 3er Bundle (sucht nach Input 'bundle')
            productContainer
                .find('input[value="bundle"] ~ label .bundle-price .reg_price')
                .text(formatMoney(bundlePrice3));

            // 2. Update 3+1 Bundle (sucht nach Input 'bundle-new')
            productContainer
                .find('input[value="bundle-new"] ~ label .bundle-price .reg_price')
                .text(formatMoney(bundlePrice4));

            // 3. Update Subscription
            productContainer
                .find(".subs-price .reg_price")
                .text(formatMoney(subscriptionPrice));

            // Rabatt-Label und Staffel-Hinweis auf die aktive Stufe synchronisieren
            let activeTier = activePlanSelect(productContainer).attr("data-discount-tier");
            productContainer.find(".subs-discount-label, .subs-plan-note").each(function () {
                this.hidden = $(this).attr("data-discount-tier") !== activeTier;
            });
        });
    }

    function updateCartQuantity() {
        $(".product-subscription").each(function () {
            let selectedOption = $(this)
                    .find('input[name="subscription"]:checked')
                    .val(),
                quantityInput = $(".quantity__input");

            selectedOption === "bundle"
                ? quantityInput.removeAttr("disabled").val(3)
                : quantityInput.attr("disabled", "disabled").val(1);
        });
    }

    function updateSellingPlanId() {
        $(".product-subscription").each(function () {
            let productContainer = $(this),
                oName = productContainer
                    .find('input[name="subscription"]:checked')
                    .val();

            console.log("oName " + oName);

            if (oName === "subscription") {
                let sellingPlanId = activePlanSelect(productContainer)
                    .find("option:selected")
                    .val();

                sellingPlanId
                    ? ($("#selling_plan_id").val(sellingPlanId),
                      console.log("✅ selling_plan_id gesetzt:", sellingPlanId))
                    : console.error("❌ Fehler: selling_plan_id ist leer!");
            } else {
                $("#selling_plan_id").val("");
            }
        });
    }

    initializeSubscriptionOptions();
    updateSubscriptionPrice();
    forceTwoDecimalsInSubscription();

    $(".subscription-loading-overlay").fadeOut(300);

    $(".subscription-input, .selling_plan").on("change", function () {
        $(this)
            .closest(".subscription-item")
            .addClass("active")
            .siblings()
            .removeClass("active");

        updateCartQuantity();
        updateSellingPlanId();
        updateSubscriptionPrice();
        forceTwoDecimalsInSubscription();
    });

    $(document).on("variant:change", function () {
        initializeSubscriptionOptions();
        updateCartQuantity();
        updateSubscriptionPrice();
        updateSellingPlanId();
        forceTwoDecimalsInSubscription();
    });

    $("form[action='/cart/add']").on("submit", function () {
        updateCartQuantity();
        updateSellingPlanId();

        let sellingPlan = $("#selling_plan_id").val();
        console.log("🛒 Wird in den Warenkorb gesendet: selling_plan_id =", sellingPlan);
    });

    /* --- LOGIK FÜR 3+1 BUNDLE (Portiert aus script.js) --- */
    
    // 1. UI Ein/Ausblenden
    const bundleNewRadio = document.getElementById("bundle-new");
    const fourPackBox = document.querySelector(".four-pack-ui");
    const allRadios = document.querySelectorAll('input[name="subscription"]');

    if (bundleNewRadio && fourPackBox) {
        // Event Listener für alle Radios, um die Box ein/auszuschalten
        allRadios.forEach(r => {
            r.addEventListener("change", function () {
                fourPackBox.style.display = bundleNewRadio.checked ? "block" : "none";
                
                // Preis-Update triggern, falls nötig
                updateCartQuantity(); 
            });
        });
    }

    // 2. Bildwechsel im Grid
    $(document).on("change", ".bundle-select", function() {
        const img = $(this).closest(".bundle-item").find(".bundle-img");
        const newImg = $(this).find(":selected").data("img");
        if (img.length && newImg) img.attr("src", newImg);
    });

    // 3. Add to Cart Interceptor
    // Wir müssen den Standard-Submit verhindern, wenn "bundle-new" gewählt ist
    $("form[action='/cart/add'] button[type='submit'], .product-form__submit").on("click", function(e) {
        
        // Prüfen, ob das 3+1 Radio ausgewählt ist
        if (document.getElementById("bundle-new") && document.getElementById("bundle-new").checked) {
            e.preventDefault();
            e.stopImmediatePropagation(); // Wichtig!

            let items = [];
            // Sammelt die 4 Produkte aus den Dropdowns
            $(".bundle-select").each(function() {
                items.push({
                    id: $(this).val(),
                    quantity: 1
                });
            });

            console.log("Füge 3+1 Bundle hinzu:", items);

            // AJAX Request an Shopify
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({ items })
            })
            .then(response => response.json())
            .then(() => {
                console.log("Bundle erfolgreich hinzugefügt.");
                // Events feuern, damit der Warenkorb (z.B. CandyRack oder Drawer) aufgeht
                document.dispatchEvent(new Event('cart:add', { bubbles: true }));
                document.dispatchEvent(new Event('cart:updated', { bubbles: true }));
                
                // Optional: Seite neu laden oder Drawer öffnen, falls oben nichts passiert
                // window.location.href = "/cart"; 
            })
            .catch(err => console.error('Fehler beim Hinzufügen:', err));

            return false;
        }
    });

    // 4. Update Cart Quantity Anpassung
    // Das vorhandene updateCartQuantity in script DE.js muss erweitert werden, 
    // oder wir überschreiben es hier leicht für den visuellen Effekt im Quantity Input
    $('input[name="subscription"]').on('change', function() {
        if ($(this).val() === 'bundle-new') {
             $(".quantity__input").removeAttr("disabled").val(4);
        }
    });
});

//# sourceMappingURL=/s/files/1/0564/6263/9291/t/66/assets/script.js.map?v=1739972020